/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ContentProductListOutAvailability = typeof ContentProductListOutAvailability[keyof typeof ContentProductListOutAvailability] | null;


export const ContentProductListOutAvailability = {
  available: 'available',
  upcoming: 'upcoming',
  expired: 'expired',
} as const;
